<button *appRole="['IndiceAjusteContrato.Crear']"   mat-raised-button color="primary" (click)="openDialog('Agregar',{})">
    <mat-icon>add</mat-icon>
    Nueva Indice de Ajuste
</button>
<button *appRole="['IndiceAjusteContrato.Listar']"  [routerLink]="['/indicesajustecontrato']" color="info"  >Listado</button>
